import { Button, Flex, SectionMessage, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EmberRoute } from '../../../../../../enums/emberRoute'
import { useSegment } from '../../../../../../hooks'
import { useEmberTransitionTo } from '../../../../../../hooks/routing/useEmberTransitionTo'

export const SkatNotAvailableMessage = () => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { transitionTo } = useEmberTransitionTo()

  const handleAddCvrClick = useCallback(() => {
    track('xxx - Bookkeeping - DK VAT integration', {
      buttonClick: 'Add CVR',
    })
    transitionTo(EmberRoute.SettingsOrganization)
  }, [track, transitionTo])

  return (
    <SectionMessage variant="error" showIcon={false}>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{t('skat.no_cvr')}</Text>
        <Button onClick={handleAddCvrClick}>{t('skat.add_cvr')}</Button>
      </Flex>
    </SectionMessage>
  )
}
